<template>
  <div>
    <div class="verify-c">
      <b-modal ref="resendTicket" id="resendTicket" title="Success!">
        <div class="p-5">
          <div class="text-center mb-3">
            <img
              width="47"
              height="auto"
              src="@/assets/img/svg/tick-mark.svg"
            />
          </div>
          <div class="text-center text-success mt-3 mt-md-0">
            Your ticket has been sent to registered email address.
          </div>
        </div>
      </b-modal>
    </div>
    <div>
      <div class="transaction-tabs-wrapper ">
        <div>
          <button
            class="btn-transparent mr-2"
            v-for="(item, index) in TabTransacton"
            :key="index"
            @click="showTransaction(item)"
            :class="tabVal == item.val ? 'active' : ''"
            style="outline:none"
          >
            {{ item.text }}
          </button>
        </div>
        <!-- <div class="pr-3 d-none d-lg-block">
        <date-picker v-model="time3" range format="MMM DD,YYYY" @change="dateChange"></date-picker>
      </div> -->
      </div>
    </div>
    <div v-if="transctions.length > 0">
      <div v-for="(trans, transKey) in transctions" :key="transKey" class>
        <!-- MY TRANSACTION DESKTOP TICKET -->
        <div class="d-none d-lg-block">
          <div class="corner-circle-top mt-5 mx-2 overflow-hidden">
            <div class="corner-circle-bottom bg-light m-ticket-web">
              <!--  -->
              <div class="col-12">
                <div class="row">
                  <div class="col-8 p-4 p-xl-5">
                    <div class="h-100">
                      <div class="row">
                        <div class="col-4 col-xl-3 pr-0 pr-xl-3">
                          <img
                            v-lazy="trans.md_thumbnail_url"
                            class="img-fluid rounded"
                          />
                        </div>

                        <div class="col-8 col-xl-9">
                          <div class="px-3">
                            <!-- FIRST ROW -->
                            <div class>
                              <p
                                class="text-capitalize font-weight-bold mb-0 ticket-mtitle"
                              >
                                {{ trans.movie_name }}
                              </p>
                              <ul class="list-inline m-tick-mInfo">
                                <li class="list-inline-item">
                                  {{ trans.movie_language }} ({{
                                    trans.movie_format
                                  }})
                                </li>
                                <li class="list-inline-item">
                                  {{ trans.ss_start_date | moment }}
                                </li>
                                <li class="list-inline-item">
                                  {{ trans.movie_rating }}
                                </li>
                              </ul>
                            </div>

                            <!-- SECOND ROW -->
                            <div
                              class="d-flex justify-content-between align-items-end my-3"
                            >
                              <div>
                                <p class="mb-0 txt14-light-blue">
                                  {{ trans.cine_name }} -
                                  {{ trans.screen_name }}
                                </p>
                                <!-- <p class="mb-0">{{trans.Address}}</p> -->
                                <div
                                  class="d-flex align-items-center text-dark"
                                >
                                  <div>
                                    <!-- <span>{{ trans.timing[0] }}</span>
                                    <span class="tfText">
                                      {{ trans.timing[1] }}
                                      <span class="mx-1">|</span>
                                    </span> -->
                                  </div>
                                  <div class="mr-1">
                                    <span class
                                      >{{ trans.ss_start_date | moment }} |
                                      {{ timeFormat(trans.t_show_time) }}</span
                                    >
                                    <!-- <span>{{trans.month}}, {{trans.year}}</span> -->
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- THIRD ROW -->
                            <div
                              class="d-flex justify-content-between align-items-center my-3"
                            >
                              <div>
                                <p
                                  class="text-muted mb-0 tiny"
                                  v-if="trans.booking_type_id == 3"
                                >
                                  Seats: (All Booked)
                                </p>
                                <p class="text-muted mb-0 tiny" v-else>
                                  Seats:
                                  {{
                                    trans.seat_names &&
                                      trans.seat_names.split(",").length
                                  }}
                                </p>
                                <ul class="list-inline mt-seat-list mb-0">
                                  <li
                                    class="list-inline-item mx-0"
                                    v-if="trans.booking_type_id == 3"
                                  >
                                    {{
                                      trans.seat_name &&
                                        trans.seat_name
                                          .split(",")
                                          .join(", ")
                                          .replace("Hall", "Auditorium")
                                    }}
                                  </li>
                                  <li class="list-inline-item mx-0" v-else>
                                    {{
                                      trans.seat_names &&
                                        trans.seat_names.split(",").join(", ")
                                    }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <!-- FOURTH ROW -->
                            <div class="m-ticket-details">
                              <div class="row mb-2">
                                <div class="col-xl-9 col-md-8 text-muted tiny">
                                  Ticket Price
                                </div>
                                <div class="col-md-4 col-xl-3 amt-text tiny">
                                  {{ curr_code }}
                                  {{ currFormat(trans.sb_total_net_amount) }}
                                </div>
                              </div>

                              <div
                                class="m-ticket-details"
                                v-if="
                                  trans.chargeTypeArray &&
                                    trans.chargeTypeArray.length > 0
                                "
                              >
                                <div
                                  class="row mb-2"
                                  v-for="(charge,
                                  chargeIndex) in trans.chargeTypeArray"
                                  :key="chargeIndex"
                                >
                                  <div
                                    class="col-xl-9 col-md-8 text-muted tiny"
                                  >
                                    {{ charge.ct_name }}
                                  </div>
                                  <div class="col-md-4 col-xl-3 amt-text tiny">
                                    {{ curr_code }}
                                    {{ currFormat(charge.tax_amount) }}
                                  </div>
                                </div>
                              </div>

                              <div class="row mb-2">
                                <div class="col-md-8 col-xl-9 text-muted tiny">
                                  Discount
                                </div>
                                <div class="col-md-4 col-xl-3 amt-text tiny">
                                  {{ curr_code }}
                                  {{ currFormat(trans.offer_price) }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- LAST ROW -->
                          <div
                            class="px-3 mt-2 pt-2 d-md-none d-lg-block mt-border-top"
                          >
                            <div class="m-ticket-details">
                              <div class="row mb-2">
                                <div
                                  class="col-xl-9 col-md-8 ticket-mtitle font-weight-bold"
                                >
                                  Total
                                </div>
                                <div
                                  class="col-md-4 col-xl-3 ticket-mtitle font-weight-bold pr-0"
                                >
                                  {{ curr_code }}
                                  {{
                                    currFormat(
                                      trans.sb_total_amount_paid -
                                        trans.offer_price - 
                                        trans.TaxOffer
                                    )
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-4 text-center p-3 p-lg-3 p-xl-5 mt-border mt-qr-section"
                  >
                    <div
                      class="h-100 d-flex align-items-center justify-content-center"
                    >
                      <div class="w-100">
                        <p class="info" v-if="true">
                          Use this QR Code to Enter the Cinema
                        </p>
                        <div class="pb-2">
                          <img
                            :src="trans.qrcode"
                            :alt="'name'"
                            height="150px"
                            width="150px"
                            class="img-fluid qr-code"
                          />
                          <!-- <div class="tag" v-if="trans.ConfirmedStatus==false && (trans.ShowStatus=='0' || trans.ShowStatus=='2' )">{{trans.ShowStatusMsg}}</div> -->
                        </div>
                        <!-- <div v-if="trans.Resend">
                        <router-link
                          class="txt14-light-blue"
                          to
                          v-on:click.native="onResendTicket(trans.BookingID)"
                        >Resend Movie Ticket</router-link>
                        </div>-->

                        <!-- PROGRESS BAR -->
                        <div class="pt-3 pb-4">
                          <div
                            class="pb-1 text-center"
                            v-if="
                              trans.booking_type_id != 3 &&
                                trans.booking_type_id
                            "
                          >
                            <p
                              class="mb-0 font-weight-bold confText"
                              :style="
                                show_status(trans).isConfirmed == 'N'
                                  ? 'color:red'
                                  : 'color:green'
                              "
                            >
                              {{ show_status(trans).status }}
                            </p>
                          </div>
                          <div
                            v-if="
                              trans.booking_type_id != 3 &&
                                trans.booking_type_id
                            "
                          >
                            <!-- Unconfirmed -->
                            <b-progress
                              v-if="trans.booking_type_id == 2"
                              :max="show_status(trans).max"
                              class="proBar ticket-proBar mb-0"
                              :class="
                                show_status(trans).isConfirmed == 'N'
                                  ? 'red'
                                  : 'bg-success'
                              "
                            >
                              <b-progress-bar :value="show_status(trans).value">
                                <p
                                  class="mb-0 succ-text"
                                  :class="
                                    show_status(trans).isConfirmed == 'N'
                                      ? ' status-text-h'
                                      : ''
                                  "
                                >
                                  {{ show_status(trans).message }}
                                </p>
                              </b-progress-bar>
                            </b-progress>
                            <!-- Confirmed -->
                            <b-progress
                              v-if="trans.booking_type_id == 1"
                              :max="parseInt(100)"
                              class="proBar ticket-proBar mb-0"
                            >
                              <b-progress-bar :value="parseInt(100)">
                                <p class="mb-0 succ-text">
                                  {{ show_status(trans).message }}
                                </p>
                              </b-progress-bar>
                            </b-progress>
                          </div>
                          <div v-else-if="trans.booking_type_id == 3">
                            <b-progress
                              :max="parseInt(trans.screen_total_seats)"
                              class="proBar ticket-proBar bg-warning mb-0"
                            >
                              <b-progress-bar></b-progress-bar>
                              <p class="mb-0 reqText mx-auto pr-2">
                                Private Screening
                              </p>
                            </b-progress>
                          </div>
                          <div v-else>
                            <b-progress
                              :max="parseInt(100)"
                              class="proBar ticket-proBar bg-success mb-0"
                            >
                              <b-progress-bar></b-progress-bar>
                              <p class="mb-0 reqText mx-auto pr-2">
                                Regular Screening
                              </p>
                            </b-progress>
                          </div>
                          <div
                            v-if="
                              trans.ShowStatusMsg == 'UNCONFIRMED' ||
                                trans.ShowStatusMsg == 'CONFIRMED'
                            "
                          >
                            <div
                              :id="'tooltip-button-' + (transKey + 1)"
                              class="btn-share"
                              @click="copyTextShare(transKey)"
                            >
                              <p style="cursor:pointer">Share</p>
                            </div>
                          </div>
                          <b-tooltip
                            :show="trans.show"
                            :disabled="true"
                            :target="'tooltip-button-' + (transKey + 1)"
                            placement="bottom"
                            variant="outline-success"
                            custom-class="tool-tip-cop"
                          >
                            <strong>Copied</strong>
                          </b-tooltip>
                        </div>
                        <!-- <div class="text-danger font-weight-bold pt-3">CANCELLED</div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-11 mx-auto mt-3">
            <ul class="list-inline">
              <li class="list-inline-item mr-3">
                <p class="mb-1 text-muted">Booking Date &amp; Time:</p>
                <span
                  >{{ trans.transaction_date_time | date }} |
                  {{ timeFormat(GetTime(trans.transaction_date_time)) }}</span
                >
                <!--  <span>{{trans.timing[0]}}</span>
              <span class="tfText">
                {{ trans.timing[1] }}
                <span class="mx-1">| {{trans.MovieDate | moment}}</span>
                </span>-->
              </li>
              <li class="list-inline-item mr-3">
                <p class="mb-1 text-muted">Payment Method</p>
                <span>{{ trans.payment_mode }}</span>
              </li>
              <li class="list-inline-item">
                <p class="mb-1 text-muted">Booking ID</p>
                <span>{{ trans.sb_booking_code }}</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- MY TRANSACTION MOBILE TICKET -->
        <div class="d-block d-lg-none d-none" v-if="false">
          <div
            v-if="trans.Resend"
            class="corner-circle-top my-5 mx-2 ticket-shadow mt-tick"
          >
            <div class="corner-circle-bottom">
              <div class="col-12 bg-light py-5 px-3">
                <div class="row">
                  <div class="col-4">
                    <img :src="trans.Image" class="img-fluid rounded" />
                  </div>

                  <div class="col-8 pl-0">
                    <p
                      class="text-capitalize font-weight-bold mb-0 ticket-mtitle"
                    >
                      {{ trans.Title }}
                    </p>
                    <ul class="list-inline m-tick-mInfo">
                      <li class="list-inline-item">{{ trans.Language }}</li>
                      <li class="list-inline-item">{{ trans.Runtime }}</li>
                      <li class="list-inline-item">{{ trans.Year }}</li>
                      <li class="list-inline-item">{{ trans.Rated }}</li>
                    </ul>
                    <!-- SECOND ROW -->
                    <div
                      class="d-flex justify-content-between align-items-end mt-3"
                    >
                      <div>
                        <p class="mb-0 txt14-light-blue">
                          {{ trans.CinemaName }} {{ trans.ScreenNo }}
                        </p>
                        <!-- <p class="mb-0">{{trans.Address}}</p> -->
                        <div class="d-flex align-items-center text-dark">
                          <div>
                            <span>{{ trans.timing[0] }}</span>
                            <span class="tfText">
                              {{ trans.timing[1] }}
                              <span class="mx-1">|</span>
                            </span>
                          </div>
                          <div class="mr-1">
                            <span class>{{ trans.MovieDate }}</span>
                            <!-- <span>{{trans.month}}, {{trans.year}}</span> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <!-- THIRD ROW -->
                    <div
                      class="d-flex justify-content-between align-items-center my-3 px-3"
                    >
                      <div>
                        <p class="text-muted mb-0 tiny">
                          Seats: {{ trans.SeatsBooked }}
                        </p>
                        <ul class="list-inline mt-seat-list mb-0">
                          <li class="list-inline-item mx-0">
                            {{ trans.Seats }}
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="m-ticket-details px-3">
                      <div
                        class="d-flex justify-content-between align-items-center mb-2"
                      >
                        <p class="mb-0 text-muted tiny">Ticket Price</p>
                        <p class="mb-0 amt-text tiny">
                          {{ trans.Currency }} {{ trans.TotalPrice }}
                        </p>
                      </div>

                      <div
                        class="d-flex justify-content-between align-items-center mb-2"
                      >
                        <p class="mb-0 text-muted tiny">GST</p>
                        <p class="mb-0 amt-text tiny">
                          {{ trans.Currency }} {{ trans.GST }}
                        </p>
                      </div>

                      <div
                        class="d-flex justify-content-between align-items-center mb-2"
                      >
                        <p class="mb-0 text-muted tiny">Service Charge</p>
                        <p class="mb-0 amt-text tiny">
                          {{ trans.Currency }} {{ trans.TicketHandling }}
                        </p>
                      </div>

                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <p class="mb-0 text-muted tiny">Discount</p>
                        <p class="mb-0 amt-text tiny">
                          {{ trans.Currency }} {{ trans.Discount }}
                        </p>
                      </div>
                    </div>

                    <!-- LAST ROW -->
                    <div class="pl-3 mt-2 pt-2 mt-border-top">
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <p class="mb-0 ticket-mtitle font-weight-bold">Total</p>
                        <p class="mb-0 ticket-mtitle font-weight-bold">
                          {{ trans.Currency }} {{ trans.Total }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="col-12 align-self-center text-center">
                    <p class="info" v-if="trans.ShowStatus == '1'">
                      Use this QR Code to Enter the Cinema
                    </p>
                    <div class="pb-2">
                      <img
                        :src="trans.QRCode"
                        :alt="'name'"
                        height="150px"
                        width="150px"
                        class="img-fluid qr-code"
                      />
                      <!-- <div class="tag">unconfirmed</div> -->
                    </div>
                    <!-- <div v-if="trans.Resend">
                    <router-link
                      class="txt14-light-blue"
                      to
                      v-on:click.native="onResendTicket(trans.BookingID)"
                    >Resend Movie Ticket</router-link>
                    </div>-->

                    <!-- PROGRESS BAR -->
                    <div class="pt-3 pb-4">
                      <div
                        class="pb-1 text-center"
                        v-if="
                          trans.booking_type_id != 3 && trans.booking_type_id
                        "
                      >
                        <p
                          class="mb-0 font-weight-bold confText"
                          :style="
                            show_status(trans).isConfirmed == 'N'
                              ? 'color:red'
                              : 'color:green'
                          "
                        >
                          {{ show_status(trans).status }}
                        </p>
                      </div>
                      <div
                        v-if="
                          trans.booking_type_id != 3 && trans.booking_type_id
                        "
                      >
                        <!-- Unconfirmed -->
                        <b-progress
                          v-if="trans.booking_type_id == 2"
                          :max="show_status(trans).max"
                          class="proBar ticket-proBar mb-0"
                          :class="
                            show_status(trans).isConfirmed == 'N'
                              ? 'red'
                              : 'bg-success'
                          "
                        >
                          <b-progress-bar :value="show_status(trans).value">
                            <p
                              class="mb-0 succ-text"
                              :class="
                                show_status(trans).isConfirmed == 'N'
                                  ? ' status-text-h'
                                  : ''
                              "
                            >
                              {{ show_status(trans).message }}
                            </p>
                          </b-progress-bar>
                        </b-progress>
                        <!-- Confirmed -->
                        <b-progress
                          v-if="trans.booking_type_id == 1"
                          :max="parseInt(100)"
                          class="proBar ticket-proBar mb-0"
                        >
                          <b-progress-bar :value="parseInt(100)">
                            <p class="mb-0 succ-text">
                              {{ show_status(trans).message }}
                            </p>
                          </b-progress-bar>
                        </b-progress>
                      </div>
                      <div v-else-if="trans.booking_type_id == 3">
                        <b-progress
                          :max="parseInt(trans.screen_total_seats)"
                          class="proBar ticket-proBar bg-warning mb-0"
                        >
                          <b-progress-bar></b-progress-bar>
                          <p class="mb-0 reqText mx-auto pr-2">
                            Private Screening
                          </p>
                        </b-progress>
                      </div>
                      <div v-else>
                        <b-progress
                          :max="parseInt(100)"
                          class="proBar ticket-proBar bg-success mb-0"
                        >
                          <b-progress-bar></b-progress-bar>
                          <p class="mb-0 reqText mx-auto pr-2">
                            Regular Screening
                          </p>
                        </b-progress>
                      </div>
                    </div>
                    <div class="pt-3 pb-0 px-3 px-md-4">
                      <div class="pb-1 text-center">
                        <p
                          class="mb-0 font-weight-bold"
                          :style="
                            trans.ShowStatus == '3' || trans.ShowStatus == '2'
                              ? 'color:red'
                              : ''
                          "
                        >
                          {{ trans.ShowStatusMsg }}
                        </p>
                      </div>
                      <div>
                        <!-- Unconfirmed -->
                        <b-progress
                          v-if="
                            trans.ConfirmedStatus == false &&
                              trans.ShowStatus == '0'
                          "
                          :max="parseInt(trans.TotalSeat)"
                          class="proBar ticket-proBar red mb-0"
                        >
                          <b-progress-bar
                            :value="trans.SeatsBooked"
                          ></b-progress-bar>
                          <p
                            :class="trans.ConfirmedStatus ? 'd-none' : ''"
                            class="mb-0 reqText mx-auto pr-2"
                            v-html="trans.ExpiryMsg"
                          ></p>
                        </b-progress>
                        <!-- Confirmed -->
                        <b-progress
                          v-if="
                            trans.ConfirmedStatus && trans.ShowStatus == '1'
                          "
                          :max="parseInt(trans.TotalSeat)"
                          class="proBar ticket-proBar mb-0"
                        >
                          <b-progress-bar :value="parseInt(trans.TotalSeat)">
                            <p class="mb-0 succ-text">
                              {{
                                parseInt(trans.TotalSeat) -
                                  parseInt(trans.SeatsBooked)
                              }}
                              Seats Left
                            </p>
                          </b-progress-bar>
                        </b-progress>
                      </div>
                    </div>
                    <!-- <div class="text-danger font-weight-bold pt-3">CANCELLED</div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-11 mx-auto mt-3" v-if="trans.Resend">
            <ul class="list-inline">
              <li class="list-inline-item mb-3">
                <p class="mb-1 text-muted tiny">Booking Date &amp; Time:</p>
                <span class="tiny">{{ trans.BookingDate }}</span>
              </li>
              <li class="list-inline-item mb-3">
                <p class="mb-1 text-muted tiny">Payment Method</p>
                <span class="tiny">{{ trans.PaymentMethod }}</span>
              </li>
              <li class="list-inline-item mb-3">
                <p class="mb-1 text-muted tiny">Booking ID</p>
                <span class="tiny">{{ trans.BookingID }}</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- NEW MOBILE M-TICKET -->
        <div class="col-12 col-md-8 mx-auto px-0 d-block d-lg-none">
          <div class="new-mTicket bg-light">
            <div class="ticket-info">
              <div class="px-3 py-3">
                <div
                  class="d-flex align-items-center justify-content-between mb-3"
                >
                  <div>
                    <img src="@/assets/img/svg/new-gogo-logo.svg" alt />
                  </div>

                  <div class="text-right">
                    <!-- <img src="@/assets/img/svg/close-icon-new.svg" class="ml-auto" alt /> -->
                    <p class="pt-2">Ticket No :{{ trans.sb_booking_code }}</p>
                  </div>
                </div>
                <div class="col-12 px-0">
                  <!-- MOVIE DETAILS -->
                  <div class="border-bottom pb-2">
                    <p class="movie-title">{{ trans.movie_name }}</p>
                    <ul class="list-inline extra-movie-info py-1">
                      <li class="list-inline-item">
                        {{ trans.movie_language }}
                      </li>
                      <li class="list-inline-item">{{ trans.movie_format }}</li>
                    </ul>
                    <p class="dark-txt">{{ trans.cine_name }}</p>
                  </div>
                  <!-- TICKET INFO -->
                  <div class="row pt-2">
                    <div class="col-8">
                      <div class="mb-3">
                        <p class="light-txt">Date :</p>
                        <p class="dark-txt">
                          {{ trans.ss_start_date | moment }}
                        </p>
                      </div>

                      <div class="mb-3">
                        <p class="light-txt">
                          Seats : - ({{ trans.seat_names }})
                        </p>
                        <ul class="list-inline m-ticket-seats">
                          <li
                            class="list-inline-item"
                            v-for="(item, index) in trans.seat_names
                              ? trans.seat_names.split(',')
                              : []"
                            :key="index"
                          >
                            {{ item }}
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div class="col-4">
                      <div class="mb-3">
                        <p class="light-txt">Time :</p>
                        <p class="dark-txt">
                          {{ timeFormat(trans.t_show_time) }}
                        </p>
                      </div>

                      <div class="mb-3">
                        <p class="light-txt">Screen</p>
                        <p class="dark-txt">{{ trans.screen_name }}</p>
                      </div>
                    </div>
                  </div>

                  <!-- TICKET PRICE -->
                  <div class="row pb-2">
                    <div class="col-8">
                      <p class="light-txt mb-1">Ticket Price</p>
                      <p
                        class="light-txt mb-1"
                        v-for="(charge, chargeIndex) in trans.chargeTypeArray"
                        :key="chargeIndex"
                      >
                        {{ charge.ct_name }}
                      </p>
                      <p class="light-txt mb-1">Service Charge</p>
                      <p class="light-txt mb-1">Discount</p>
                    </div>

                    <div class="col-4">
                      <p class="normal-txt">
                        {{ curr_code }}
                        {{ currFormat(trans.sb_total_net_amount) }}
                      </p>
                      <p
                        class="normal-txt"
                        v-for="(charge, chargeIndex) in trans.chargeTypeArray"
                        :key="chargeIndex"
                      >
                        {{ curr_code }}
                        {{ currFormat(charge.tax_amount) }}
                      </p>
                      <p class="normal-txt">
                        {{ curr_code }} {{ currFormat(trans.offer_price) }}
                      </p>
                    </div>
                  </div>

                  <!-- TICKET PRICE TOTAL -->
                  <div class="row border-top pt-2">
                    <div class="col-8">
                      <p class="light-txt">Total</p>
                    </div>

                    <div class="col-4">
                      <p class="dark-txt">
                        {{ curr_code }}
                        {{
                          currFormat(
                            trans.sb_total_amount_paid - trans.offer_price
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="qr-section qr-section pt-3 pb-5">
              <!-- PROGRESS BAR -->
              <div class="pt-3 pb-4">
                <div
                  class="pb-1 text-center"
                  v-if="trans.booking_type_id != 3 && trans.booking_type_id"
                >
                  <p
                    class="mb-0 font-weight-bold confText"
                    :style="
                      show_status(trans).isConfirmed == 'N'
                        ? 'color:red'
                        : 'color:green'
                    "
                  >
                    {{ show_status(trans).status }}
                  </p>
                </div>
                <div v-if="trans.booking_type_id != 3 && trans.booking_type_id">
                  <!-- Unconfirmed -->
                  <b-progress
                    v-if="trans.booking_type_id == 2"
                    :max="show_status(trans).max"
                    class="proBar ticket-proBar mb-0"
                    :class="
                      show_status(trans).isConfirmed == 'N'
                        ? 'red'
                        : 'bg-success'
                    "
                  >
                    <b-progress-bar :value="show_status(trans).value">
                      <p
                        class="mb-0 succ-text"
                        :class="
                          show_status(trans).isConfirmed == 'N'
                            ? ' status-text-h'
                            : ''
                        "
                      >
                        {{ show_status(trans).message }}
                      </p>
                    </b-progress-bar>
                  </b-progress>
                  <!-- Confirmed -->
                  <b-progress
                    v-if="trans.booking_type_id == 1"
                    :max="parseInt(100)"
                    class="proBar ticket-proBar mb-0"
                  >
                    <b-progress-bar :value="parseInt(100)">
                      <p class="mb-0 succ-text">
                        {{ show_status(trans).message }}
                      </p>
                    </b-progress-bar>
                  </b-progress>
                </div>
                <div v-else-if="trans.booking_type_id == 3">
                  <b-progress
                    :max="parseInt(trans.screen_total_seats)"
                    class="proBar ticket-proBar bg-warning mb-0"
                  >
                    <b-progress-bar></b-progress-bar>
                    <p class="mb-0 reqText mx-auto pr-2">
                      Private Screening
                    </p>
                  </b-progress>
                </div>
                <div v-else>
                  <b-progress
                    :max="parseInt(100)"
                    class="proBar ticket-proBar bg-success mb-0"
                  >
                    <b-progress-bar></b-progress-bar>
                    <p class="mb-0 reqText mx-auto pr-2">
                      Regular Screening
                    </p>
                  </b-progress>
                </div>
              </div>
              <!-- <div
                class="pt-3 pb-0 px-3 px-md-4"
                :style="trans.booking_type_id == 3 ? 'margin: 2px 54px;' : ''"
              >
                <div
                  class="new-progress-bar bg-warning"
                  v-if="trans.booking_type_id == 3"
                >
                  <b-progress style="width:0%" :max="parseInt(100)">
                    <b-progress-bar></b-progress-bar>
                  </b-progress>
                  <p class="proBar-text">Private Screening</p>
                </div>
              </div> -->

              <div class="align-self-center text-center">
                <p class="qr-note" v-if="trans.ShowStatus == '1'">
                  Use this QR Code to Enter the Cinema
                </p>
                <div class="py-3">
                  <img
                    :src="trans.qrcode"
                    alt="'name'"
                    height="150px"
                    width="150px"
                    class="img-fluid qr-code"
                  />
                  <!-- <div class="tag">unconfirmed</div> -->
                </div>
                <div
                  v-if="
                    (trans.ShowStatusMsg == 'Unconfirmed' ||
                      trans.ShowStatusMsg == 'Confirmed') &&
                      false
                  "
                >
                  <navigator-share
                    v-bind:on-error="onError"
                    v-bind:on-success="onSuccess"
                    :text="
                      trans.Seats != 'Private Booking - Complete Hall Booked'
                        ? 'Join me on GoGoCinema to watch ' +
                          trans.Title +
                          ' at ' +
                          trans.CinemaName +
                          ' on ' +
                          trans.MovieDate +
                          ' at ' +
                          trans.timing[0] +
                          ' ' +
                          trans.timing[1] +
                          '. Click the below link to join: \n' +
                          trans.shortLinkPwa
                        : 'I have booked a private screening on GoGoCinema! Join me to watch ' +
                          trans.Title +
                          ' at ' +
                          trans.CinemaName +
                          ' on ' +
                          trans.MovieDate +
                          ' at ' +
                          trans.timing[0] +
                          ' ' +
                          trans.timing[1] +
                          '.'
                    "
                    class="btn-share"
                  ></navigator-share>
                  <!-- <router-link class="txt14-light-blue" to>
                  <img src="@/assets/img/svg/share-btn-img.svg" alt />
                  </router-link>-->
                </div>
                <!-- <div class="text-danger font-weight-bold pt-3">CANCELLED</div> -->
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
    <div v-else-if="loading == false" class="row ">
      <div class="col-12 text-center">
        <h5>No Transaction</h5>
      </div>
    </div>
    <div class="row " v-if="loading">
      <div class="col-12 text-center">
        <img src="@/assets/img/loadMore.gif" class="load-more" />
      </div>
    </div>
  </div>
</template>
<script>
import { makeRequest } from "@/helper/internet.js";
import { TokenService } from "@/services/storage.service";
import NavigatorShare from "vue-navigator-share";
import moment from "moment";
import EventBus from "@/eventBus.js";
import DatePicker from "vue2-datepicker";
import MainServices from "@/services/mainService.js";
import AuthServices from "@/services/AuthServices.js";
import debounce from "debounce";
import "vue2-datepicker/index.css";
export default {
  data() {
    return {
      show: true,
      transctions: [],
      ticketMessage: "",
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      loading: true,
      time3: [new Date(), new Date()],
      TabTransacton: [
        {
          text: "Upcoming",
          val: "Confirmed",
          status: 16
        },
        {
          text: "Pending",
          val: "Unconfirmed",
          status: 20
        },
        {
          text: "Expired",
          val: "Expired",
          status: 13
        },
        {
          text: "Cancelled",
          val: "Cancelled",
          status: 14
        }
      ],
      tabVal: "Confirmed",
      tempTransactions: []
    };
  },
  computed: {
    curr_code() {
      return this.$store.getters.getCurrCode;
    },
    userInfo() {
      if (localStorage.getItem("user")) {
        let user = JSON.parse(localStorage.getItem("user"));
        return user;
      } else {
        return false;
      }
    }
  },
  beforeMount() {
    let date = moment().add(30, "days");
    this.time3 = [new Date(), date._d];
    // this.fetchNotifications();
    this.fetchUserHistory();
  },
  beforeDestroy() {
    EventBus.$emit("FOOTERSET", false);
    EventBus.$emit("CHECKROUTE", false);
  },
  mounted() {
    EventBus.$emit("CHECKROUTE", true);
    EventBus.$emit("BOTTOMTABCHANGE", "3");
  },
  filters: {
    moment(date) {
      return moment(date).format("DD-MMM-YYYY");
    },
    datetime(date) {
      return moment(date).format("DD-MMM-YYYY HH:mm");
    },
    date(date) {
      return moment(date).format("DD-MMM-YYYY");
    }
  },
  components: {
    NavigatorShare,
    DatePicker
  },
  methods: {
    show_status(transaction) {
      let tempObj;
      if (transaction.booking_type_id == 2) {
        if (transaction.booked_seats >= transaction.min_seats) {
          let obj = {
            status: "Confirmed",
            message: "Confirmed",
            percent: 100,
            max: 100,
            value: 100,
            isPrivate: false,
            isConfirmed: "Y",
            screen_total_seats: transaction.screen_total_seats
          };
          tempObj = obj;
        } else {
          let remainingSeats = transaction.min_seats - transaction.booked_seats;
          let obj = {
            status: "Not Confirmed",
            message: `Need ${remainingSeats} seats to confirm`,
            percent: remainingSeats,
            max: parseInt(transaction.min_seats),
            value: parseInt(transaction.booked_seats),
            isPrivate: false,
            isConfirmed: "N",
            screen_total_seats: parseInt(transaction.screen_total_seats)
          };
          tempObj = obj;
        }
      } else if (transaction.booking_type_id == 3) {
        let obj = {
          status: "Private Screening",
          message: `Private Screening`,
          percent: 100,
          max: 100,
          value: 100,
          isPrivate: true,
          isConfirmed: "Y",
          screen_total_seats: parseInt(transaction.screen_total_seats)
        };
        tempObj = obj;
      } else {
        let obj = {
          status: "Confirmed",
          message: `Confirmed`,
          percent: 100,
          max: 100,
          value: 100,
          isPrivate: false,
          isConfirmed: "Y",
          screen_total_seats: parseInt(transaction.screen_total_seats)
        };
        tempObj = obj;
      }
      return tempObj;
    },
    GetTime(date) {
      return moment(date).format("HH:mm");
    },
    dateChange() {
      if (this.time3[0] != null) {
        this.transctions = [];
        this.loading = true;
        this.fetchNotifications();
      }
    },
    showTransaction(val) {
      if (val.val != this.tabVal) {
        this.transctions = [];
        this.loading = true;
        this.tabVal = val.val;
        setTimeout(() => {
          this.transctions = this.tempTransactions.filter(
            x => x.ss_show_status == val.status
          );
          this.loading = false;
        }, 500);
      }
    },
    copyTextShare(index) {
      var copyText = document.getElementById("copyText" + index);
      copyText.select();
      document.execCommand("copy");
      var self = this;

      this.transctions[index]["Title"] =
        this.transctions[index]["Title"] + "  ";
      this.transctions[index].show = true;
      setTimeout(function() {
        self.transctions[index].show = false;
        self.transctions[index]["Title"] =
          self.transctions[index]["Title"] + " ";
      }, 2000);
    },
    onError(err) {
      alert(err);
      console.log(err);
    },
    onSuccess(err) {
      console.log(err);
    },
    fetchUserHistory() {
      this.showLoading();
      console.log("this.userInfo", this.userInfo);
      let payload = {
        customer_id: this.userInfo ? this.userInfo.cust_id : null
      };
      AuthServices.GetUserHistory(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            EventBus.$emit("FOOTERSET", true);
            this.tempTransactions = data.Records;
            this.transctions = data.Records.filter(x => x.ss_show_status == 16);
            console.log("this.transctions", this.transctions);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        })
        .finally(() => {
          this.hideLoading();
          this.loading = false;
        });
    },
    sortSeatsString(a, b) {
      let reA = /[^a-zA-Z]/g;
      let reN = /[^0-9]/g;
      let aA = a.replace(reA, "");
      let bA = b.replace(reA, "");
      if (aA === bA) {
        let aN = parseInt(a.replace(reN, ""), 10);
        let bN = parseInt(b.replace(reN, ""), 10);
        return aN === bN ? 0 : aN > bN ? 1 : -1;
      } else {
        return aA > bA ? 1 : -1;
      }
    },

    fetchNotifications: function() {
      let payload = {
        fromDate: this.time3[0],
        toDate: this.time3[1],
        type: screen.width < 991 ? "mobile" : "desktop"
      };

      let token = TokenService.getToken();
      makeRequest("/Booking/GetBookingHistory", "POST", token, payload)
        .then(result => {
          if (result.res.data.length > 0) {
            this.tempTransactions = result.res.data;
            this.tempTransactions.map(date => {
              date.ShowStatusMsg = date.ShowStatusMsg.toLowerCase();
              date.ShowStatusMsg =
                date.ShowStatusMsg.charAt(0).toUpperCase() +
                date.ShowStatusMsg.slice(1);
              date.Seats = date.Seats.split(",").join(", ");
              let parts = date.MovieDate.replace(/,/g, "").split(" ");
              let year = parseInt(parts[2], 10);
              let month = getMonthFromString(parts[1]);
              let day = parseInt(parts[0], 10);
              let date1 = new Date(year, month, day);
              date.day = this.days[date1.getDay()];
              date.date = date1.getDate();
              date.year = year;
              date.month = this.months[date1.getMonth()];
              date.timing = date.MovieTiming.split(" ");
              date["show"] = false;
              EventBus.$emit("FOOTERSET", true);
            });

            this.transctions = this.tempTransactions.filter(x => {
              return x.ShowStatusMsg == this.tabVal;
            });
          }
          this.loading = false;
        })
        .catch(error => {
          console.log("Error", error);
        });

      function getMonthFromString(mon) {
        return new Date(Date.parse(mon + " 1, 2012")).getMonth();
      }
    },
    onResendTicket: function(BookingID) {
      this.showLoading();
      let token = TokenService.getToken();
      let payload = {
        BookingID: BookingID
      };
      makeRequest("/Booking/ResendBookingDetails", "POST", token, payload)
        .then(result => {
          this.hideLoading();
          const { error, res } = result;
          if (!error) {
            this.$refs.resendTicket.show();
            setTimeout(() => {
              this.$refs.resendTicket.hide();
            }, 5000);
          }
        })
        .catch(error => {
          console.log("error :", error);
          this.hideLoading();
        });
    }
  }
};
</script>

<style>
.transaction-tabs-wrapper {
  width: 100%;
  display: flex;
  margin-bottom: 15px;
  flex-wrap: nowrap;
  overflow-y: hidden;
  overflow-x: auto;
  justify-content: space-between;
  border-bottom: 1px solid #d3d3d3;
}

.status-text-h {
  position: absolute;
  left: 100px;
}
/* 
.transaction-tabs-wrapper>div{
  display: flex;
  overflow-x: auto;
  flex-wrap: nowrap;
} */
.btn-transparent {
  border: none;
  padding: 10px;
  color: #2b2d42;
  border: 2px solid transparent;
  background-color: transparent;
}
.btn-transparent.active {
  font-weight: bold;
  color: #000;
  border-bottom: 2px solid #000;
}

.profile-content input[type="text"],
.profile-content input[type="email"],
.profile-content input[type="number"],
.profile-content input[type="password"] {
  height: 40px !important;
}
.mx-datepicker-range {
  width: 210px;
}

@media (max-width: 992px) {
  .profile-content {
    margin-top: 25px;
  }
  .transaction-tabs-wrapper {
    width: calc(100% + 30px);
    justify-content: space-between;
    margin-left: -15px;
    margin-right: -15px;
  }

  .transaction-tabs-wrapper > div {
    display: flex;
    padding: 0 15px;
    width: 100%;
    justify-content: space-between;
  }
  .transaction-tabs-wrapper .btn-transparent {
    padding: 5px;
  }
}

@media (max-width: 360px) {
  .transaction-tabs-wrapper .btn-transparent {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/myTransaction.vue